import { BannerMap } from "components/AppImageUploader";
import { UploadBannerFailureAction, UploadBannerSuccessAction } from "../actions/UploadBanner";
import { AppState } from "../state";

export function uploadBannerSuccess(state: AppState, action: UploadBannerSuccessAction): AppState {
    const { app } = action.payload;
    const appImagesMap = state.uploadedImages && state.uploadedImages[app.appId] ? state.uploadedImages[app.appId] : {};

    const bannerMap: BannerMap = {
        banner: app.banner,
        largeBanner: app.largeBanner
    };

    return {
        ...state,
        uploadedImages: {
            ...state.uploadedImages,
            [app.appId]: {
                ...appImagesMap,
                banner: bannerMap
            }
        }
    };
}

export function uploadBannerFailure(state: AppState, action: UploadBannerFailureAction): AppState {
    const errorMap = { ...state.errorMap };

    errorMap[action.type] = action.payload.error;
    return { ...state, errorMap };
}
